// extracted by mini-css-extract-plugin
export default {"root":"Select_root__weeN3","handleIcon":"Select_handleIcon__OfQ96","handleIconOpen":"Select_handleIconOpen__cjun5","button":"Select_button__AWdNj"};